import gql from 'graphql-tag';
import graphqlClient from '@shared/graphql/client';

export class StripeAuditService {
  static async create(data) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation STRIPEAUDIT_CREATE(
          $data: StripeAuditInput!
        ) {
          stripeAuditCreate(data: $data) {
            id
          }
        }
      `,

      variables: {
        data
      },
    });

    return response.data.stripeAuditCreate;
  }
}
